<template>
    <div>
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav></hq-nav>
            </div>
        </el-header>
        <el-main style="background: #000000;" id="contBox" ref="contBox">
            <p class="indexBt">波形系列</p>
            <div class="contBox" >
                <ul class="tabs">
                    <li @click="liSwitch('ky','宽带中规模MANET')" :class="{ clickLi:cur === 'ky' }">
                        <img src="../assets/images/icon_red_ky.png" alt="">
                        <span>鲲鱼系列</span>
                    </li>
                    <li @click="liSwitch('hh','窄带大规模MANET')" :class="{ clickLi:cur === 'hh' }">
                        <img src="../assets/images/icon_red_hh.png" alt="">
                        <span>鸿鹄系列</span>
                    </li>
                    <li @click="liSwitch('pn','宽带大规模MANET')" :class="{ clickLi:cur === 'pn' }">
                        <img src="../assets/images/icon_red_pn.png" alt="">
                        <span>鹏鸟系列</span>
                    </li>
                    <li @click="liSwitch('zl','宽带超大规模链状MANET')" :class="{ clickLi:cur === 'zl' }">
                        <img src="../assets/images/icon_red_zl.png" alt="">
                        <span>烛龙系列</span>
                    </li>
                    <li @click="liSwitch('cl','宽带点对点')" :class="{ clickLi:cur === 'cl' }">
                        <img src="../assets/images/icon_red_cl.png" alt="">
                        <span>苍鸾系列</span>
                    </li>
                    <li @click="liSwitch('cm','宽带点对点')" :class="{ clickLi:cur === 'cm' }">
                        <img src="../assets/images/icon_red_cm.png" alt="">
                        <span>重明系列</span>
                    </li>
                    <el-divider direction="vertical" class="fg"></el-divider>
                    <li @click="liSwitch(5)" :class="{ clickLi:cur == 5 }">
                        <img src="../assets/images/icon_6.png" alt="">
                        <a href="javascript:void(0)">波形对比</a>
                    </li>
                </ul>
                <div class="tabsCont">
                    <p class="bxts" v-if="this.btShow"> {{ bxts }} </p>
                    <div v-for="(cont,index) in dataCont" :key="index" class="listCont">
                        <ul>
                            <li>
                                <img :src="require('../assets/images/'+cont.img)" alt="">
                            </li>
                            <li>
                                <div class="bt">
                                    <img :src="require('../assets/images/'+cont.btIcon)" alt="">
                                    <p>{{cont.btText}}</p>
                                    <a href="javascript:void(0)" @click="aClick(cont.btnHref)">了解更多</a>
                                </div>
                                <p class="text">{{cont.cont}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </el-main>
        <el-footer class="footer">
            <hq-footer></hq-footer>
        </el-footer>

        <el-dialog title="波形对比" :visible.sync="vdlDialog" width="80%" top="10vh" @open="diaOpen">
            <hq-vdl :fMes="data1"></hq-vdl>
        </el-dialog>
    </div>

</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";
    import VDLCont from "./VDLCont";

    export default {
        name: "ContIndex",
        data () {
            return {
                cur:0,
                dataCont:[],
                vdlDialog:false,
                tabsData:require("../assets/JSON/TabsCont.json"),
                data1:"",
                bxts:"宽带中规模MANET",
                btShow:false
            }
        },
        methods:{
            liSwitch(e,t){
                this.bxts = t;
                if (e === 5){
                    this.cur = e;
                    // this.vdlDialog = true;
                    this.$router.push({
                        path:`/vdlIndex/VDLData/波形系列对比表`,
                    });
                }else{
                    this.cur = e;
                    this.$router.push({
                        path:`/contIndex/${e}/`,
                    });
                }
            },
            aClick(link){
                this.$router.push({
                    path:`/moduleDetail/${link}`,
                });
            },
            setHeight(){
                let bodyH = document.body.clientHeight;
                let windowH = document.documentElement.clientHeight;
                let div = document.getElementById('contBox');

                div.style.minHeight = (div.clientHeight + (windowH - bodyH)) + "px";
            },
            diaOpen(){
                this.data1 = "VDLData.json";
            }
        },
        created() {
            this.dataCont = this.tabsData.tabsCont.cont0;

        },
        mounted() {
            let type = this.$route.params.type;
            switch (type) {
                case 'ky':
                    this.cur = "ky";
                    this.dataCont = this.tabsData.tabsCont.cont0;
                    break;
                case 'hh':
                    this.cur = "hh";
                    this.dataCont = this.tabsData.tabsCont.cont1;
                    break;
                case 'pn':
                    this.cur = "pn";
                    this.dataCont = this.tabsData.tabsCont.cont2;
                    break;
                case 'zl':
                    this.cur = "zl";
                    this.dataCont = this.tabsData.tabsCont.cont3;
                    break;
                case 'cl':
                    this.cur = "cl";
                    this.dataCont = this.tabsData.tabsCont.cont4;
                    break;
                case 'cm':
                    this.cur = "cm";
                    this.dataCont = this.tabsData.tabsCont.cont5;
                    break;
                default:
                    alert(123);
            }
            this.setHeight();
        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer,
            "hq-vdl":VDLCont
        }
    }
</script>

<style scoped>
    .indexBt{
        background: #000000;
        color: #ffffff;
        text-align: center;
        margin: 0;
        box-sizing: border-box;
        font-size: 2rem;
        padding-top: 2rem;
        font-family: AlibabaPuHuiTi-Heavy;
    }
    .navbg{
        background: url("../assets/images/navbg.jpg") no-repeat top center;
        background-size: 100% 100%;
    }

    .tabs{
        width: 100%;
        height: 4.8125rem;
        overflow: hidden;
        margin: 3rem 0 0 0;
        padding: 0;
    }
    .tabs li{
        float: left;
        list-style: none;
        width: 12rem;
        height: 100%;
        background: #232323;
        text-align: center;
        line-height: 4.8125rem;
        color: #ffffff;
        padding: 0;
        margin-right: 1rem;
        cursor: pointer;
        font-family: AlibabaPuHuiTi-Light;
    }
    .tabs li:last-child{
        float: right;
        width: 4.875rem;
        line-height: normal;
        margin-right: 0;
    }
    .tabs li:last-child img{
        display: block;
        width: 2.125rem;
        height: 2.125rem;
        margin: 0.5rem 1.4rem 0;
    }
    .tabs li img{
        display: inline-block;
        width: 2.625rem;
        height: 2.625rem;
        float: left;
        margin: 1rem 1rem 0 1.5rem;
    }
    .tabs li span{
        float: left;
    }
    .tabs li a{
        text-decoration: none;
        color: #ffffff;
    }
    .tabs li.clickLi,
    .tabs li:hover{
        background: #e7211a;
    }
    .fg{
        float: left;
        margin: 1rem 1.5rem 0 1rem;
        height: 3rem;
        background: #292929;
        width: 2px;
    }
    .tabsCont{
        width: 100%;
        height: auto;
        margin: 3.8rem 0;
    }
    .listCont{
        width: 100%;
        height: 13rem;
        overflow: hidden;
        margin: 1.4375rem 0;
    }
    .listCont ul{
        margin: 0;
        padding: 0;
        height: auto;
        width: 100%;
        overflow: hidden;
    }
    .listCont ul li{
        list-style: none;
    }
    .listCont ul li:first-child{
        float: left;
        width: 29rem;
        height: 13rem;
        overflow: hidden;
    }
    .listCont ul li:first-child img{
        width: 100%;
        height: 100%;
    }
    .listCont ul li:last-child{
        float: right;
        width: 53.125rem;
        height: 13rem;
    }
    .listCont ul li .bt{
        width: 100%;
        height: 3.5rem;
        color: #ffffff;
        font-size: 1.5rem;
        font-weight: bold;
        border-bottom: 2px solid #e7211a;
        margin-top:2rem;
        font-family: AlibabaPuHuiTi-Medium;
    }
    .listCont ul li .bt img{
        width: 2.6875rem;
        height: 2.5625rem;
        float: left;
    }
    .listCont ul li .bt p{
        float: left;
        margin: 0 0 0 1rem;
        line-height: 2.5rem;

    }
    .listCont ul li .bt a{
        display: block;
        float: right;
        width: 10.25rem;
        height: 2.6875rem;
        line-height: 2.6875rem;
        text-align: center;
        font-size: 1rem;
        color: #ffffff;
        text-decoration: none;
        background: #e7211a;
        font-weight: normal;
    }
    .listCont ul li .text{
        width: 100%;
        height: auto;
        line-height: 1.875rem;
        text-align: left;
        color: #888888;
        font-family: AlibabaPuhuiTiR;
    }
    .bxts{
        margin: 0;
        color: #e7211a;
        font-family: AlibabaPuHuiTi-Light;
    }
</style>
